import styles from "./Allergens.module.css"
import Navbar from "../../components/Navbar/NavbarMain/Navbar";
import Footer from "../../components/Footer/Footer";
import Alergen from "../../components/Cards/AlergenCard/AlergenCard";
import { alergenMap } from "../../constants/alergens";
import { useTranslation } from "react-i18next";
import PageLayout from "../../components/Layout/PageLayout/PageLayout";
/**
* Allergen page.
* Contains info about all the allergens.
* @returns TSX.Element
*/
const Allergens = () => {
    const { t } = useTranslation(); // Translation

    return(
        <PageLayout
            pageClassName={styles.Page}
            headerClassName={styles.Header}
            headerInnerClassName={styles.Headergroup}
            contentClassName={styles.Content}
            footerClassName={styles.Footer}
            header={<Navbar />}
            footer={<Footer />}
        >
            <div className={styles.AlergenInfo}>
                <p className={styles.AlergenInfoTitle}>{t("allergens.title")}</p>
                <p className={styles.AlergenInfoText}>
                    {t("allergens.text")}
                </p>
            </div>
            <div className={styles.AlergenList}>
                <div className={styles.AlergenListColumn}>
                    {alergenMap.map((alergen,i)=>{
                        if(i < 7 ){
                            return(
                                <div className={styles.Alergen}>
                                    <Alergen title={alergen.title}/>
                                    <p className={styles.AlergenDesc}>{t(`allergens.allergens.${i+1}`)}</p>
                                </div>
                            )}})}
                </div>
                <div className={styles.AlergenListColumn}>
                    {alergenMap.map((alergen,i)=>{
                        if(i > 6 ){
                            return(
                                <div className={styles.Alergen}>
                                    <Alergen title={alergen.title}/>
                                    <p className={styles.AlergenDesc}>{t(`allergens.allergens.${i+1}`)}</p>
                                </div>
                            )}})}
                </div>
            </div>
        </PageLayout>
    )
};

export default Allergens;
